import { EventLabelsModel } from '@/v2/models/eventTicketsModel';
import { MultiEventEnvelopeModel } from '@/v2/models/multiEventEnvelopeModel';

export function getEventLabels(envelope: MultiEventEnvelopeModel, eventId: number): EventLabelsModel | undefined {
  return envelope?.eventTickets?.find((eventTickets) => eventTickets.event?.id === eventId)?.labels;
}

/**
 * An override only wins when PBS actually gave us text for it - a missing or blank label means the
 * host has not customized that field, so our own translation stands.
 */
export function resolveLabel(override: string | undefined | null, fallback: string): string {
  return override?.trim() || fallback;
}
